import { IntegrationDialogProps } from "@custom-types/integrations-types";
import { Grid2, SvgIcon, Typography } from "@mui/material";
import { INTEGRATION_INFO } from "@src/constants/integrations-constants";
import { DEFAULT_INPUT_FONT_SIZE } from "@styles/common-styles";
import { Dialog } from "@flat-ui";

/** Shows dialog for integration in progress */
export function IntegrationsInProgressDialog({
  integrationId,
  dialogCancelCallback,
}: IntegrationDialogProps): JSX.Element {
  return (
    <Dialog
      open={true}
      onConfirm={dialogCancelCallback}
      confirmText="Cancel authorization"
      title=""
    >
      <Grid2
        alignItems="center"
        container
        flexDirection="column"
      >
        <SvgIcon
          inheritViewBox={true}
          component={INTEGRATION_INFO[integrationId].icon}
          sx={{ marginBottom: "30px", width: "95px", height: "95px" }}
        />
        <Typography
          sx={{
            fontSize: "20px",
            marginBottom: "30px",
          }}
        >
          {INTEGRATION_INFO[integrationId].displayName} authorization
        </Typography>
        <Typography
          sx={{
            fontSize: DEFAULT_INPUT_FONT_SIZE,
            marginTop: "0px",
            marginBottom: "30px",
          }}
        >
          Please complete the authorization in the window that just opened.
        </Typography>
      </Grid2>
    </Dialog>
  );
}
